import type * as Y from "yjs"
import Collaboration from "@tiptap/extension-collaboration"
import CollaborationCursor from "@tiptap/extension-collaboration-cursor"

import type { HocuspocusProvider } from "@hocuspocus/provider"
import { caret } from "../extensions/remote-cursors"
import { SHARED_FIELD } from "./shared-doc"

export interface CollaboratorUser {
	userId: string
	name: string
	color: string
}

/** Binds the editor to the shared doc and draws teammates' carets like the rest of the app. */
export function sharedDocExtensions({
	ydoc,
	provider,
	user,
}: {
	ydoc: Y.Doc
	provider: HocuspocusProvider
	user: CollaboratorUser
}) {
	return [
		Collaboration.configure({ document: ydoc, field: SHARED_FIELD }),
		CollaborationCursor.configure({
			provider,
			user,
			render: (peer: Record<string, unknown>) =>
				caret(String(peer.name ?? ""), String(peer.color ?? "#5e6ad2")),
			selectionRender: (peer: Record<string, unknown>) => ({
				style: `background-color: ${String(peer.color ?? "#5e6ad2")}33`,
			}),
		}),
	]
}
